import { format, parseISO } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { capitalizeFirstLetter } from './string';

export function resolveTicketByTicketType(tickets, type, category) {
    return tickets.find(t => t.type === type && t.category === category);
}

export function getParentTicket(tickets, child) {
    return tickets.find(t => !t.locked
        && t.type !== child.type
        && t.category === child.category,
    );
}

export function getChildTicket(tickets, category, type) {
    return tickets.find(t => t.locked
        && t.type === type
        && t.category === category,
    );
}

export function getTicketByCategoryAndType(tickets, category, type) {
    return tickets.find(t => t.category === category && t.type === type);
}

export function getNumberOfTicketsById(tickets, id) {
    return tickets.filter(t => t.id === id).length;
}

export function getTicketTypes(tickets) {
    return tickets.reduce(
        (types, ticket) => {
            if (types.indexOf(ticket.type) === -1) {
                return [...types, ticket.type];
            }

            return types;
        },
        [],
    );
}

export function formatTicketVenue(ticket) {
    return [
        ticket.venue.arena.title,
        ticket.venue.cities[0].title,
    ].join(', ');
}

export function formatTicketDate(ticket) {
    const formatted = [
        format(
            parseISO(ticket.all_dates[0]),
            'EEEE dd LLLL',
            {
                locale: enUS,
            },
        ),
    ].filter(Boolean);

    if (ticket.all_dates.length > 1) {
        formatted.push(
            format(
                parseISO(ticket.all_dates[ticket.all_dates.length - 1]),
                'EEEE dd LLLL',
                {
                    locale: enUS,
                },
            ),
        );

        return capitalizeFirstLetter(formatted.join(' to '));
    } else if (ticket.time !== '00:00') {
        formatted.push(ticket.time);
    }

    return capitalizeFirstLetter(formatted.join(' '));
}
